import { React, useState, useEffect } from 'react';
import style from './../../utils/modals.module.scss';
import { CloseOutlined } from '@ant-design/icons';
import moment from 'moment';

const CustomSideModal = ({ setShowSideBar, showSideBar, visitData }) => {
  const {
    sideBarPos,
    sideBarContainer,
    sideBarHeader,
    sellReqOwner,
    reqDataContainer,
    light,
    close,
  } = style;
  const [closingBar, setClosingBar] = useState(false);

  useEffect(() => {
    if (showSideBar) {
      setClosingBar(false);
    }
  }, [showSideBar]);

  const handleClose = () => {
    setClosingBar(true);
    setTimeout(() => {
      setShowSideBar(false);
    }, 150);
  };

  return (
    <div className={sideBarContainer}>
      {showSideBar && (
        <div className={`${closingBar ? close : ''}`}>
          <div className={`${sideBarPos}`}>
            <div className={sideBarHeader}>
              <div className={sellReqOwner}>
              </div>
              <div>
                <CloseOutlined onClick={handleClose} />
              </div>
            </div>
            <div className={reqDataContainer}>
              <div>
                <h4>Visitador</h4>
                <h4 className={light}>{visitData.user?.fullName}</h4>
              </div>
              <div>
                <h4>Visitador número de cuenta</h4>
                <h4 className={light}>{visitData.user?.accountNumber}</h4>
              </div>
              <div>
                <h4>Visitador email</h4>
                <h4 className={light}>{visitData.user?.email}</h4>
              </div>
              <div>
                <h4>Visitador rol</h4>
                <h4 className={light}>{visitData.user?.role}</h4>
              </div>
              <div>
                <h4>Stand</h4>
                <h4 className={light}>{visitData.stand?.name}</h4>
              </div>
              <div>
                <h4>Stand N°</h4>
                <h4 className={light}>
                  {visitData.stand?.standNumber}
                </h4>
              </div>
              <div>
                <h4>Stand hall</h4>
                <h4 className={light}>
                  {visitData.stand?.section}
                </h4>
              </div>
              <div>
                <h4>Visitado el</h4>
                <h4 className={light}>{moment(visitData.createdAt).format('DD-MM-YYYY HH:mm')}</h4>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomSideModal;